import React, { useState, useEffect, useRef, Fragment } from 'react'
import { Link, withRouter, useHistory } from 'react-router-dom'
import { withAuth } from '../../AuthContext'
import Modal from 'react-modal'
import Chip from '@mui/material/Chip'
import MediaQuery from 'react-responsive'
import Notification from './../../Utils/Notification'
import { INFO } from './../../../utils/constants'
import '../../css/chat.css'
import { ChatMessage } from '../../Utils/ChatMessage'
import { NotificationByPlaceBadge } from '../Notification/NotificationBadge'
import { useNotification } from '../Notification/NotificationContext'

Modal.setAppElement('#root')

const ListRequests = ({ type, auth }) => {
  const [requests, setRequests] = useState([])
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const requestsRef = useRef([])
  const user = auth.user
  const [requestIdToCancel, setRequestIdToCancel] = useState(null)
  const [messages, setMessages] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const modalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  }

  const processRequests = (response) => {
    let results = []

    const sortedBookings = [...response.data].sort((a, b) => {
      return new Date(b.request_sent_at).getTime() - new Date(a.request_sent_at).getTime()
    })
    sortedBookings.forEach((request, index) => {
      let status =
        request.status.toLowerCase() === 'pending-verification'
          ? 'PENDING'
          : request.status.toUpperCase()
      results.push(
        <BookingRequest
          key={request.id}
          guests={request.guests}
          host={request.host}
          place={request.place}
          message={request.message}
          unReadMessages={request.unReadMessages.length}
          currency={request.currency}
          propertyPrice={request.property_price}
          status={status}
          startDate={request.start_date}
          endDate={request.end_date}
          hostReason={request.hostReason}
          index={index}
          request={request}
          requestsRef={requestsRef}
          isPaid={request.paymentStatus === 'succeeded'}
          originalStatus={request.status}
          isPendingProfile={
            user.proofIdentityStatus !== 'completed' &&
            (user.status === 'partiallycompleted' ||
              user.status === 'registered')
          }
          isPendingId={user.status === 'approved' || user.status == 'completed'}
          cancelRequest={cancelRequest}
          setRequestIdToCancel={setRequestIdToCancel}
          openModal={openModal}
          isLoading={isLoading}
          messages={request.messages}
        />
      )
    })
    setRequests(results)
  }

  const openModal = () => {
    setModalIsOpen(true)
  }

  const closeModal = () => {
    setModalIsOpen(false)
  }

  const cancelRequest = (id) => {
    axios
      .post(`/api/bookings/requests/cancel/${id}`)
      .then((response) => {
        processRequests(response)
        Notification({
          type: INFO,
          message: 'Your request has been cancelled',
        })
      })
      .catch((error) => {
        console.log('Request failure: ', error)
      })
  }

  const getRequests = () => {
    axios
      .get('/api/bookings/requests', {
        params: {
          type: type,
        },
      })
      .then((response) => {
        console.log(response)
        processRequests(response)
      })
      .catch((error) => {
        console.log('Request failure: ', error)
      })
  }

  useEffect(() => {
    getRequests()
  }, [])

  if (requests.length === 0) {
    return (
      <section id="bookingRequests" style={{ marginTop: '40px' }}>
        <div className="text-center">
          <p>
            Homestay booking requests you make with other members will appear
            here.
          </p>
        </div>
      </section>
    )
  } else {
    return (
      <section id="bookingRequests" className="main-wrapper">
        <div className="container">
          <ul className="responsive-table">
            <li className="table-header">
              <div className="col-field-1">Place</div>
              <div className="col-field-2">Nº Guests</div>
              <div className="col-field-3">Arrival date</div>
              <div className="col-field-4">Departure date</div>
              <div className="col-field-5">Status</div>
              <div className="col-icon" />
            </li>
            {requests}
          </ul>
        </div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={modalStyles}
          contentLabel="Confirmation"
          bodyOpenClassName="bookingSection-modal"
        >
          <div className="bookingSection__modal-wrapper">
            <h5>Are you sure?</h5>
            <div className="bookingSection__modal-wrapper__button-wrapper">
              <div
                className="btn btn-gray font-open-sans font-size-14 font-weight-700 text-white"
                onClick={closeModal}
              >
                No
              </div>
              <div
                className="btn btn-green font-open-sans font-size-14 font-weight-700 text-white"
                onClick={(e) => {
                  cancelRequest(requestIdToCancel)
                  closeModal()
                }}
              >
                Yes
              </div>
            </div>
          </div>
        </Modal>
      </section>
    )
  }
}

const BookingRequest = ({
  currency,
  propertyPrice,
  guests,
  status,
  startDate,
  endDate,
  host,
  place,
  index,
  requestsRef,
  isPaid,
  isPendingProfile,
  isPendingId,
  request,
  setRequestIdToCancel,
  openModal,
  isLoading,
  messages,
  unReadMessages,
}) => {
  const [expanded, setExpanded] = useState(false)
  const history = useHistory()
  const { fetchUnreadCount } = useNotification()

  const handleGoToMessage = async () => {
    const from = window.location.pathname
    console.log(from)
    const id = request.id
    try {
      const response = await axios.post(`/api/messages/mark-message-as-read`, {
        id,
      })
      console.log('Message update response:', response.data)
    } catch (error) {
      console.error('Error updating unread messages:', error.message || error)
    }
    fetchUnreadCount() // refresh the unread in the context file
    history.push(`/send-message/${id}`, { from }) // Pass the previous page as state
  }

  const expand = (e, index) => {
    if (
      !e.target.classList.contains('btn') &&
      !e.target.classList.contains('buttons-container')
    ) {
      if (expanded) {
        requestsRef.current[index].style.height = ''
      } else {
        let infoHeight = requestsRef.current[index].children[1].offsetHeight
        let messageHeight = requestsRef.current[index].children[2].offsetHeight
        let totalHeight =
          requestsRef.current[index].children[0].offsetHeight +
          infoHeight +
          messageHeight +
          29
        requestsRef.current[index].style.height = `${totalHeight}px`
      }
      setExpanded(!expanded)
    }
  }

  const RequestText = () => {
    switch (status) {
      case 'COMPLETED':
        // return 'We hope you enjoyed your stay. Don\'t forget to leave a review!';
        return ''
      case 'APPROVED':
        if (isPaid) {
          return 'Your payment has been processed and your booking confirmed. Enjoy your stay!'
        } else {
          return 'Your request has been accepted by the host. Click the green button to pay.'
        }
      case 'PENDING':
        if (isPendingProfile) {
          return 'Your booking request cannot be sent to the host until you verify your Freebird account by completing your profile. Click the green button to complete it.'
        } else if (isPendingId) {
          return 'Your booking request cannot be sent to the host until you verify your Freebird account by uploading a photo ID. Click the green button to verify your account.'
        } else {
          return 'Your request has been sent to the host. When the host responds you will be notified by email and the status of your request will change here.'
        }
    }
  }

  const ButtonStack = ({ isMobile }) => {
    if (!isMobile) {
      switch (status) {
        case 'PENDING':
          if (!isPendingProfile && !isPendingId) {
            return (
              <div
                className="col-7 d-flex align-items-end justify-content-end"
                data-label="Actions"
              >
                <div className="row buttons-container w-100">
                  <div className="col-12">
                    <div className="row justify-content-end">
                      <Link
                        className="btn btn-white font-open-sans font-size-14 font-weight-700 text-black"
                        to="#"
                        onClick={(e) => {
                          e.preventDefault()
                          handleGoToMessage()
                        }}
                        dangerouslySetInnerHTML={{
                          __html: `Message host`,
                        }}
                      />
                      <div
                        className="btn btn-red font-open-sans font-size-14 font-weight-700 text-white"
                        onClick={() => {
                          setRequestIdToCancel(request.id)
                          openModal()
                        }}
                      >
                        Cancel request
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          } else {
            return (
              <div
                className="col-7 d-flex align-items-end justify-content-end"
                data-label="Actions"
              >
                <div className="row buttons-container w-100">
                  <div className="col-12">
                    <div className="row justify-content-end">
                      <Link
                        className="btn btn-green font-open-sans font-size-14 font-weight-700 text-white"
                        to={{ pathname: `/dashboard` }}
                        dangerouslySetInnerHTML={{
                          __html: `Complete profile`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        case 'COMPLETED':
          return (
            <div
              className="col-7 d-flex align-items-end justify-content-end"
              data-label="Actions"
            >
              {/*
                                <div className="row buttons-container w-100">
                                    <div className="col-12">
                                        <div className="row justify-content-end">
                                            <div
                                                className="btn btn-white font-open-sans font-size-14 font-weight-700 text-black"
                                                onClick={() => {
                                                    setExpanded(false);
                                                }}
                                            >
                                                Review your stay
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                */}
            </div>
          )
        case 'APPROVED':
          if (isPaid) {
            return (
              <div
                className="col-7 d-flex align-items-end justify-content-end"
                data-label="Actions"
              >
                <div className="row buttons-container w-100">
                  <div className="col-12">
                    <div className="row justify-content-end">
                      <Link
                        className="btn btn-white font-open-sans font-size-14 font-weight-700 text-black"
                        to={{ pathname: `/send-message/${request.id}` }}
                        dangerouslySetInnerHTML={{
                          __html: `Message host`,
                        }}
                      />
                      <div
                        className="btn btn-red font-open-sans font-size-14 font-weight-700 text-white"
                        onClick={() => {
                          setRequestIdToCancel(request.id)
                          openModal()
                        }}
                      >
                        Cancel request
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          } else {
            return (
              <div
                className="col-7 d-flex align-items-end justify-content-end"
                data-label="Actions"
              >
                <div className="row buttons-container w-100">
                  <div className="col-12">
                    <div className="row justify-content-end">
                      <Link
                        className="btn btn-white font-open-sans font-size-14 font-weight-700 text-black"
                        to="#"
                        onClick={(e) => {
                          e.preventDefault()
                          handleGoToMessage()
                        }}
                        dangerouslySetInnerHTML={{
                          __html: `Message host`,
                        }}
                      />
                      <div
                        className="btn btn-red font-open-sans font-size-14 font-weight-700 text-white"
                        onClick={() => {
                          setRequestIdToCancel(request.id)
                          openModal()
                        }}
                      >
                        Cancel request
                      </div>
                      <Link
                        className="btn btn-green font-open-sans font-size-14 font-weight-700 text-white"
                        to={{
                          pathname: `/place/${place.id}`,
                          state: { bookingRequest: request },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: `Complete booking`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          }
      }
    } else {
      switch (status) {
        case 'PENDING':
          if (!isPendingProfile && !isPendingId) {
            return (
              <div className="row buttons-container d-flex flex-wrap justify-content-around">
                <Link
                  className="btn btn-white font-open-sans font-size-14 font-weight-700 text-black"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault()
                    handleGoToMessage()
                  }}
                  dangerouslySetInnerHTML={{
                    __html: `Message host`,
                  }}
                />
                <div
                  className="btn btn-red font-open-sans font-size-14 font-weight-700 text-white"
                  onClick={() => {
                    setRequestIdToCancel(request.id)
                    openModal()
                  }}
                >
                  Cancel request
                </div>
              </div>
            )
          } else {
            return (
              <div className="row buttons-container d-flex flex-wrap justify-content-around">
                <Link
                  className="btn btn-green font-open-sans font-size-14 font-weight-700 text-white"
                  to={{ pathname: `/dashboard` }}
                  dangerouslySetInnerHTML={{
                    __html: `Complete profile`,
                  }}
                />
              </div>
            )
          }
        case 'COMPLETED':
          return (
            <div className="row buttons-container d-flex flex-wrap justify-content-center">
              {/*
                                <div
                                    className="btn btn-white font-open-sans font-size-14 font-weight-700 text-black"
                                    onClick={() => {
                                        setExpanded(false);
                                    }}
                                >
                                    Review your stay
                                </div>
                                */}
            </div>
          )
        case 'APPROVED':
          if (isPaid) {
            return (
              <div className="row buttons-container d-flex flex-wrap justify-content-around">
                <Link
                  className="btn btn-white font-open-sans font-size-14 font-weight-700 text-black"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault()
                    handleGoToMessage()
                  }}
                  dangerouslySetInnerHTML={{
                    __html: `Message host`,
                  }}
                />
                <div
                  className="btn btn-green font-open-sans font-size-14 font-weight-700 text-white"
                  onClick={() => {
                    setRequestIdToCancel(request.id)
                    openModal()
                  }}
                >
                  Cancel request
                </div>
              </div>
            )
          } else {
            return (
              <div className="row buttons-container d-flex flex-wrap justify-content-around">
                <Link
                  className="btn btn-white font-open-sans font-size-14 font-weight-700 text-black"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault()
                    handleGoToMessage()
                  }}
                  dangerouslySetInnerHTML={{
                    __html: `Message host`,
                  }}
                />
                <div
                  className="btn btn-red font-open-sans font-size-14 font-weight-700 text-white"
                  onClick={() => {
                    setRequestIdToCancel(request.id)
                    openModal()
                  }}
                >
                  Cancel request
                </div>
                <Link
                  className="btn btn-green font-open-sans font-size-14 font-weight-700 text-white"
                  to={{
                    pathname: `/place/${place.id}`,
                    state: { bookingRequest: request },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: `Complete booking`,
                  }}
                />
              </div>
            )
          }
      }
    }
  }

  return (
    <div
      className={`table-row-container${expanded ? ' expanded' : ''}`}
      ref={(el) => (requestsRef.current[index] = el)}
    >
      <li className="table-row">
        <div className="col-field-1" data-label="Place">
          {place.name}
        </div>
        <div className="col-field-2" data-label="Nº Guests">
          {guests}
        </div>
        <div className="col-field-3" data-label="Check-in">
          {startDate}
        </div>
        <div className="col-field-4" data-label="Check-out">
          {endDate}
        </div>
        <div
          className={`col-field-5 tag-${status.toLowerCase()}`}
          data-label="Status"
        >
          <Chip label={status} />
        </div>
        <div className={`col-icon${expanded ? ' expanded' : ''}`}>
          <div className="arrow-icon" onClick={(e) => expand(e, index)} />
        </div>
        <NotificationByPlaceBadge count={unReadMessages} />
      </li>
      <div className="col-12 mb-4">
        <div className="row">
          <div className="col-12 col-md-6 mb-3">
            <div className="row property-details">
              <div className="col-5 col-md-12 text-right text-md-left details-text">
                <div className="row">
                  <div className="font-all-round font-weight-300 font-size-20 text-black w-100 mb-2">
                    Property Details:
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="row">
                  <div className="col-5 d-flex justify-content-end justify-content-md-start  justify-content-xs-start">
                    <div className="row">
                      <div className="place-image">
                        <img
                          src={s3AwsEndpoint + '/' + place.photo}
                          onError={(e) => {
                            e.target.onError = null
                            e.target.src =
                              '/images/listing/profile-coming-soon.png'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-7">
                    <div className="row ml-0">
                      <span className="font-all-round font-weight-600 font-size-20 text-black w-100">
                        {place.name}
                      </span>
                      <span className="font-open-sans font-weight-600 font-size-14 w-100">
                        <img src="/images/icons/location.svg" alt="" />{' '}
                        {place.location}
                      </span>
                      <span
                        className="font-open-sans font-weight-600 font-size-14 w-100"
                        dangerouslySetInnerHTML={{
                          __html: `<img src="/images/icons/tag.svg" alt=""/> ${currency}${propertyPrice} - per night`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row host-details">
              <div className="col-5 col-md-12 text-right text-md-left details-text">
                <div className="row">
                  <div className="font-all-round font-weight-300 font-size-20 text-black w-100 mb-2">
                    Host Details:
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="row">
                  <div className="col-5 d-flex justify-content-end justify-content-md-start justify-content-xs-start">
                    <div className="row">
                      <div className="host-image">
                        <img
                          src={s3AwsEndpoint + '/' + host.photo}
                          onError={(e) => {
                            e.target.onError = null
                            e.target.src =
                              '/images/listing/profile-coming-soon.png'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-7">
                    <div className="row ml-0">
                      <h5 className="m-0 w-100">
                        <Link to={`/user/${host.id}`} className="font-size-20">
                          {host.name}
                        </Link>
                      </h5>
                      <span className="font-open-sans font-weight-600 font-size-14 w-100">
                        <img src="/images/icons/location.svg" alt="" />{' '}
                        {host.location}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-12 mb-3">
            <MediaQuery minWidth={768}>
              <div className="justify-content-center">
                <RequestText />
              </div>
            </MediaQuery>
            <MediaQuery maxWidth={767}>
              <div className="justify-content-center">
                <RequestText />
              </div>
            </MediaQuery>
          </div>

          <div className="col-12 col-md-12 mb-3">
            {messages.length > 0 && (
              <div class="chat-preview-container">
                {messages.length >= 3 && (
                  <Link
                    className="continue-chat-link"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault()
                      handleGoToMessage()
                    }}
                    dangerouslySetInnerHTML={{
                      __html: `view older messages...`,
                    }}
                  />
                )}

                {isLoading ? (
                  <div className="loading-spinner">
                    <p>Loading...</p>
                  </div>
                ) : messages.length > 0 ? (
                  messages
                    .slice() // To avoid mutating the original array
                    .reverse()
                    .map((msg, index) => (
                      <ChatMessage
                        key={index}
                        classType={'chat-preview-message'}
                        className={msg.userId === host.id ? 'host' : 'guest'}
                        message={msg.message}
                        timestamp={msg.sendDate}
                      />
                    ))
                ) : (
                  ''
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {}

      <li className="table-row table-row__expanded-content">
        <Fragment>
          <MediaQuery minWidth={768}>
            <ButtonStack isMobile={false} />
          </MediaQuery>
          <MediaQuery maxWidth={767}>
            <ButtonStack isMobile={true} />
          </MediaQuery>
        </Fragment>
      </li>
    </div>
  )
}

export default withRouter(withAuth(ListRequests))
